import { AssessmentStatusFromId } from '../../../constants/chips/assessment-status.constants';
import { EvidenceStatusFromId } from '../../../constants/chips/evidence-status.constants';
import { RatingsFromId } from '../../../constants/chips/ratings.constants';

const createDynamicPeriodColumns = (isSecondPeriod) => {
    if (isSecondPeriod) {
        // In Period 2 (Oct-Dec): September shows previous, December shows current
        return [
            {
                displayName: 'September',
                sortColumnName: 'previousRatingId',
                dataType: 'indicator-chip',
                dataKey: 'previousRatingId',
                converter: (id) => RatingsFromId(id),
                settings: { sort: false, filter: false, multiple: false },
            },
            {
                displayName: 'December',
                sortColumnName: 'ratingId',
                dataType: 'indicator-chip',
                dataKey: 'ratingId',
                converter: (id) => RatingsFromId(id),
                settings: { sort: false, filter: false, multiple: false },
            },
        ];
    } else {
        // In Period 1 (Jan-Sept): September shows current, December shows "not assessed"
        return [
            {
                displayName: 'September',
                sortColumnName: 'ratingId',
                dataType: 'indicator-chip',
                dataKey: 'ratingId',
                converter: (id) => RatingsFromId(id),
                settings: { sort: false, filter: false, multiple: false },
            },
            {
                displayName: 'December',
                sortColumnName: 'notAssessed',
                dataType: 'indicator-chip',
                dataKey: null,
                converter: () => RatingsFromId(0),
                settings: { sort: false, filter: false, multiple: false },
            },
        ];
    }
};

export const createSubcomponentColumns = (isSecondPeriod = false) => {
    const periodColumns = createDynamicPeriodColumns(isSecondPeriod);

    return [
        {
            displayName: 'Measurable Criteria/Evidence',
            sortColumnName: 'subcomponentName',
            dataType: 'string',
            dataKey: 'subcomponentName',
            settings: { sort: false, filter: false, multiple: false, width: '50' },
        },

        {
            displayName: 'Approval Period',
            sortColumnName: 'frequency',
            dataType: 'string',
            dataKey: 'frequency',
            settings: { sort: false, filter: false, multiple: false },
        },

        {
            displayName: 'Owners',
            sortColumnName: 'owners',
            dataType: 'string',
            dataKey: 'owners',
            settings: { sort: false, filter: false, multiple: false },
        },

        ...periodColumns,

        {
            displayName: 'Status',
            sortColumnName: 'statusId',
            dataType: 'chip',
            dataKey: 'statusId',
            converter: (id) => EvidenceStatusFromId(id),
            settings: { sort: false, filter: false, multiple: true },
        },

        {
            displayName: 'Actions',
            sortColumnName: 'actions',
            dataType: 'actions',
            dataKey: null,
            settings: { sort: false, filter: false, multiple: false },
        },
    ];
};

// Default columns for backward compatibility
export const subcomponentColumns = createSubcomponentColumns(false);

export const subcomponentSortingConfig = {
    sortByColumn: 'subcomponentName',
    sortByDescending: false,
    callback: () => {},
};

export const subcomponentPaginationConfig = {
    paginationEvent: () => {},
    paginationData: {
        pageNumber: 1,
        pageSize: Number.MAX_SAFE_INTEGER,
    },
    defaultPageSize: {
        value: Number.MAX_SAFE_INTEGER,
        text: 'All',
    },
};
